//@state
export interface jobsProfileState {}
export const initialState: jobsProfileState = {}